export const EXPIRING_SOON_THRESHOLD_DAYS = 7;
